<template>
  <div :class="type">
    <template v-if="!questionsInfo.initialized || questionsInfo.search || questionsInfo.filterBy || questionsInfo.count > 0 || newQuestion || type === 'main'">
      <Filters
        v-if="!newQuestion && !detailQuestion"
        :key="questionKey"
        :type="type"
      />
      <div class="qa">
        <ListQuestions
          v-if="!newQuestion && !detailQuestion"
          :type="type"
          :lesson="lecture"
          :course="course"
          :page-props="page"
          @questions="updateQuestions"
        />
        <NewQuestion
          v-else-if="newQuestion"
          :key="`new${questionKey}`"
          :mode="mode"
          :type="type"
          :page="page"
          :lecture="lecture"
          :question="questionEdit"
        />
        <QuestionDetails
          v-else-if="detailQuestion"
          :key="`details${questionKey}`"
          :count-answers="questionInfo.answers ? questionInfo.answers.length : 0"
          :count-helpful-answers="questionInfo.answers ? questionInfo.answers.filter(a => a.helpful).length : 0"
          :type="type"
          :question-info="questionInfo"
          @voted="voted"
          @editquestion="editQuestion"
          @refreshquestion="refreshQuestion"
        />
      </div>
    </template>
    <EmptyList v-else />
  </div>
</template>

<script>
// rebuild
import Filters from './Filters';
import ListQuestions from './ListQuestions';
import EmptyList from './EmptyList';

export default {
  components: {
    Filters,
    ListQuestions,
    EmptyList,
    NewQuestion: async () => import('./NewQuestion'),
    QuestionDetails: async () => import('./QuestionDetails'),
  },

  props: {
    lecture: { type: [Number], default: 0 },
    course: { type: [Number], default: 0 },
    type: { type: [String], default: '' },
    // eslint-disable-next-line vue/require-default-prop
    page: { type: [Array, Object] },
  },
  data() {
    return {
      newQuestion: false,
      detailQuestion: false,
      questionInfo: {},
      questionKey: -1,
      questionEdit: {
        title: '',
        body: '',
        url: '',
        courseSlug: '',
      },
      mode: '',
      questionsInfo: {
        initialized: false,
        search: null,
        count: null,
      },
    };
  },
  created() {
    this.$root.$off('loadquestion');
    this.$root.$off('new-question');
    this.$root.$off('back-to-questions');
    this.$root.$on('loadquestion', (questionUrl, mode) => {
      this.loadQuestion(questionUrl, mode);
    });
    this.$root.$on('new-question', () => {
      this.newQuestion = true;
      this.$root.$emit('new-question-form', (true));
    });
    this.$root.$on('back-to-questions', () => {
      this.questionKey = this.lecture.id;
      this.newQuestion = false;
      this.detailQuestion = false;
    });
  },
  methods: {
    async refreshQuestion(questionUrl) {
      this.questionInfo = await this.$axios.$get(
        `/qa-hub/questions/${questionUrl}`,
      );
      this.questionKey = Date.now();
    },
    editQuestion(questionEdit) {
      this.newQuestion = true;
      this.mode = 'edit';
      this.questionEdit = questionEdit;
      this.questionKey = -1;
    },
    async loadQuestion(questionUrl, mode) {
      if (this.type === 'in-video') {
        this.$store.commit('courses/setCurrentQuestion', questionUrl);
      }
      this.newQuestion = false;

      if (this.type === 'in-video') {
        this.questionInfo = await this.$axios.$get(
          `/qa-hub/questions/${questionUrl}`,
        );
        this.detailQuestion = true;
        this.questionKey = this.questionInfo.id;

        // this is a workaround to avoid the issue with the count of questions
        // after the first question is created
        if (!this.questionsInfo.count && mode !== 'edit') {
          this.questionsInfo.count = 1;
        }
      } else if (mode === 'edit') {
        this.detailQuestion = true;
        this.questionInfo = await this.$axios.$get(
          `/qa-hub/questions/${questionUrl}`,
        );
        this.questionKey = this.questionInfo.id;
      } else {
        this.$router.push(`/question/${questionUrl}/`);
      }
    },
    async voted({
      subject, votes, idx,
    }) {
      if (subject === 'answers') {
        this.questionInfo.answers[idx].votes = votes;
      } else if (subject === 'questions') {
        this.questionInfo.votes = votes;
      }
    },
    updateQuestions(questionsInfo) {
      this.questionsInfo.initialized = true;
      this.questionsInfo.search = questionsInfo.filters.search;
      this.questionsInfo.filterBy = questionsInfo.filters.filterBy;
      this.questionsInfo.count = questionsInfo.questions.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.main h1 {
  color: var(--main-dark-shade-0);
  font-size: 28px;
  line-height: 34px;
  margin: 24px 0;
}

.in-video h1 {
  display: none;
}

.in-video .qa {
  padding: 0;
  min-height: 350px;
}

@include bp($bp-mobile) {
  .in-video .qa {
    margin-top: var(--spacing-20);
    padding: 0 var(--spacing-24);
  }

  ::v-deep {
    .__filters {
      .__filters-dropdown {
        .__filters-dropdown-footer {
          .clear-btn {
            color: var(--main-light-shade-4);

            svg {
              path[fill] {
                fill: var(--main-light-shade-4);
              }
            }
          }
        }
      }
    }
  }
}
</style>
